package com.sddamico.swigmore.ds.feedback

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.SwEffects
import com.sddamico.swigmore.ds.SwMotion
import com.sddamico.swigmore.ds.css
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div

val SkeletonStyle = CssStyle {
  base {
    Modifier.css("animation" to "${SwMotion.fadeInKeyframes} 200ms ease-out both")
  }
}

val SkeletonBlockStyle = CssStyle {
  base {
    Modifier.css("background" to SwColor.tintOnFieldHover,
      "animation" to "${SwMotion.pulseKeyframes} 900ms ease-in-out infinite alternate")
  }
  cssRule(SwMotion.reducedMotion) {
    Modifier.css("animation" to "none")
  }
}

/**
 * Stand-in for a page while its data loads, laid out in the page's shape so the content lands
 * without shifting it. It fades in, so a load that finishes quickly barely shows it.
 */
@Composable
fun Skeleton(modifier: Modifier = Modifier, content: @Composable () -> Unit) {
  Div(attrs = SkeletonStyle.toModifier().then(modifier).toAttrs { attr("aria-busy", "true") }) { content() }
}

/** One placeholder bar or card inside a [Skeleton]. */
@Composable
fun SkeletonBlock(
  height: String,
  modifier: Modifier = Modifier,
  width: String = "100%",
  radius: String = SwEffects.radiusCard,
) {
  Div(attrs = SkeletonBlockStyle.toModifier()
    .css("height" to height, "width" to width, "max-width" to "100%", "border-radius" to radius)
    .then(modifier).toAttrs())
}

/** Placeholder for a [com.sddamico.swigmore.ds.core.PageTitle]: eyebrow, headline and an optional lede. */
@Composable
fun PageTitleSkeleton(modifier: Modifier = Modifier, lede: Boolean = true) {
  Div(attrs = Modifier.css("display" to "flex", "flex-direction" to "column", "gap" to "12px").then(modifier).toAttrs()) {
    SkeletonBlock("11px", width = "220px", radius = SwEffects.radiusXs)
    SkeletonBlock("clamp(30px,4.4vw,46px)", width = "min(440px,80%)", radius = SwEffects.radiusXs)
    if (lede) SkeletonBlock("15px", width = "min(560px,95%)", radius = SwEffects.radiusXs)
  }
}
